











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {CargaPesquisaSatisfacao} from '@/model/resource/CargaPesquisaSatisfacao'
import {CargaPesquisaSatisfacaoCollection} from '@/model/collection/CargaPesquisaSatisfacaoCollection'
import {ListCargaPesquisaSatisfacaoSchema} from '@/schema/resource/CargaPesquisaSatisfacao/ListCargaPesquisaSatisfacaoSchema'
import {CsvCargaPesquisaSatisfacaoSchema} from '@/schema/resource/CargaPesquisaSatisfacao/CsvCargaPesquisaSatisfacaoSchema'

@Component
export default class ListCargaPesquisaSatisfacaoView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListCargaPesquisaSatisfacaoSchema()
  collection = new CargaPesquisaSatisfacaoCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: CargaPesquisaSatisfacao) {
    Helper.pushByName('editCargaPesquisaSatisfacao', item.idCargaFk)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new CargaPesquisaSatisfacaoCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvCargaPesquisaSatisfacao()
    new CsvCargaPesquisaSatisfacaoSchema().downloadCsv(csv.all())
  }
}
